import odata from 'odata-client';
import {
    GET_DRIVER_ENTRIES_REQUEST,
    GET_DRIVER_ENTRIES_ERROR,
    GET_DRIVER_ENTRIES_SUCCESS,
    TOKEN_EXPIRED
} from '../../types';
import { getServiceUrl, getDefaultHeader } from '../../../utils';
import { showNotification } from '../../notification';

export const tokenExpired = () => ({    
    type: TOKEN_EXPIRED
});

export const getDriverEntriesRequest = () => ({
    type: GET_DRIVER_ENTRIES_REQUEST,
});

export const getDriverEntriesError = errorOrResults => ({
    type: GET_DRIVER_ENTRIES_ERROR,
    error: errorOrResults.message,
});

export const getDriverEntriesSuccess = payload => ({
    type: GET_DRIVER_ENTRIES_SUCCESS,
    payload,
});

export default (pensumIds) => async (dispatch, getState) => {
    dispatch(getDriverEntriesRequest());

    const query = odata({service: getServiceUrl()}).resource("DriverEntries");
    query.expand(`Driver($expand=DriverCompany)`)
    query.expand(`MixingPlant`)
    query.expand(`Pensum($select=ID)`);
    if (pensumIds && pensumIds.length > 0) {
        query.filter(`Pensum/ID in (${pensumIds})`)
    }
    const errorOrResult = await query.get({
        headers: {
            Authorization: `Bearer ${getState().user.token}`,
            ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const errorKey = "GENERAL_SERVER_ERROR";
                return new Error(errorKey);
            } else if (!ok) {
                console.log('get employee entries api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 ? `401: ${Message}` : `${Message}`;
                return new Error(errorKey);
            } else {
                const body = JSON.parse(res.body);
                const payload = body.value;
                const driverEntriesById = {}
                payload.forEach(obj => {
                    driverEntriesById[obj.ID] = obj
                })

                return driverEntriesById;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(getDriverEntriesError(errorOrResult));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        dispatch(showNotification(errorOrResult.message, "error"))
        return;
    }

    dispatch(getDriverEntriesSuccess(errorOrResult));

    return errorOrResult;
};